import { Frequency2 } from "./CoreClient";

export const frequencyLabelLookup = {
    [Frequency2.Weekly]: "Weekly",
    [Frequency2.Fortnightly]: "Fortnightly",
    [Frequency2.FourWeekly]: "Every 4 weeks",
    [Frequency2.OneOff]: "One Off"
  };